export default __webpack_public_path__ + "static/media/69.9ecb11ba.png";